import "./styles.css"

function Load(props){

        return(
            <div className="aguardando">Aguardando...</div>
        );
}

export default Load;